import $ from 'jquery';
import '../plugins/jquery-ui';

class CalendarLoader {
	constructor() {
		this.events();
	}

	events() {
		const that = this,
	          $opentimes = $('#opentimes');
	    
	    if ($opentimes.length) {
	        that.initCalendar();

	        $(window).on('boomcms:chunkload', function(e) {
	            if (e.chunk.type === 'calendar') {
	                that.initCalendar();
	            }
	        });
	    }
	}

	initCalendar() {
		const $opentimes = $('#opentimes');

        var dates = $.parseJSON($opentimes.find('textarea').val()),
            months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

        $opentimes.find('.calendar').datepicker({
            dateFormat: "yy-mm-dd",
            beforeShowDay: function(date) {
                var year = date.getFullYear(),
                    month = ('0' + (date.getMonth() + 1)).slice(-2),
                    day = ('0' + date.getDate() ).slice(-2),
                    formatted = year + '-' + month + '-' + day,
                    className = formatted in dates ? 'hastext' : '';

                return [true, className];
            },
            onSelect: function(dateText) {
                var date = new Date(dateText),
                    description = $('body#availability').length ? 'Availability for ' : 'Opening times for ';

                if (dates[dateText]) {
                    $opentimes
                        .find('.open')
                        .show()
                        .find('h3')
                        .text(description + date.getDate() + ' ' + months[date.getMonth()] + ' ' + date.getFullYear())
                        .end()
                        .find('p')
                        .text(dates[dateText]);
                } else {
                    $opentimes.find('.open').hide();
                }
            }
        });
	}
}

export default {
	init() {
		new CalendarLoader();
	}
}


// WEBPACK FOOTER //
// ./src/js/modules/calendarLoader.js